import { LinearGradient, type LinearGradientProps } from 'expo-linear-gradient'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Image } from '@/src/elements/image'

export const CommunitiesCategoryStaticImage = ({
  imageSource,
  ...props
}: LinearGradientProps & { imageSource: string }): ReactNode => {
  return (
    <LinearGradient className="absolute flex h-full w-full flex-1 items-center" {...props}>
      <View className="relative flex h-full w-full max-w-[100vw] flex-row items-end">
        <View className="absolute bottom-16 right-12 aspect-square h-[160px] sm:bottom-4 sm:right-0 sm:h-[250px] md:h-[300px] lg:h-[400px]">
          <Image source={imageSource} />
        </View>
      </View>
    </LinearGradient>
  )
}
